import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MENU_API_URL = `${API_HOST}/api/menu`;
const MENU_PRODUCT_API_URL = `${MENU_API_URL}/product`;

function* createMenu() {
  yield takeEvery(actions.CREATE_MENU, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MENU_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MENU_ENDED });
    }
  });
}

function* createMenuProduct() {
  yield takeEvery(actions.CREATE_MENU_PRODUCT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MENU_PRODUCT_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MENU_PRODUCT_ENDED });
    }
  });
}

function* searchMenus() {
  yield takeEvery(actions.SEARCH_MENUS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MENU_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MENUS_ENDED });
    }
  });
}

function* searchMenuProducts() {
  yield takeEvery(actions.SEARCH_MENU_PRODUCTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MENU_PRODUCT_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MENU_PRODUCTS_ENDED });
    }
  });
}

function* findMenu() {
  yield takeEvery(actions.FIND_MENU, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MENU_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MENU_ENDED });
    }
  });
}

function* findMenuProduct() {
  yield takeEvery(actions.FIND_MENU_PRODUCT, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MENU_PRODUCT_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MENU_PRODUCT_ENDED });
    }
  });
}

function* searchMenuProductCategories() {
  yield takeEvery(actions.FIND_MENU_PRODUCT_CATEGORIES, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MENU_API_URL}/${id}/category`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MENU_PRODUCT_CATEGORIES_ENDED });
    }
  });
}

function* updateMenu() {
  yield takeEvery(actions.UPDATE_MENU, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MENU_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MENU_ENDED });
    }
  });
}

function* updateMenuProduct() {
  yield takeEvery(actions.UPDATE_MENU_PRODUCT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MENU_PRODUCT_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MENU_PRODUCT_ENDED });
    }
  });
}

function* updateMenuProductCategories() {
  yield takeEvery(actions.UPDATE_MENU_PRODUCT_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${MENU_API_URL}/category`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield put({ type: actions.UPDATE_MENU_PRODUCT_CATEGORIES_ENDED });
      handleError(err);
    }
  });
}

function* deleteMenus() {
  yield takeEvery(actions.DELETE_MENUS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], MENU_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MENUS_ENDED });
    }
  });
}

function* deleteMenuProducts() {
  yield takeEvery(actions.DELETE_MENU_PRODUCTS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${MENU_PRODUCT_API_URL}`, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MENU_PRODUCTS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMenu),
    fork(createMenuProduct),
    fork(searchMenus),
    fork(searchMenuProducts),
    fork(findMenu),
    fork(findMenuProduct),
    fork(searchMenuProductCategories),
    fork(updateMenu),
    fork(updateMenuProduct),
    fork(updateMenuProductCategories),
    fork(deleteMenus),
    fork(deleteMenuProducts),
  ]);
}
